export default __webpack_public_path__ + "static/media/product_test_choices_protection.033675da.jpg";